// extracted by mini-css-extract-plugin
export var dividerLine = "_3x-0";
export var errorBackground = "_3x-1";